module.exports = __webpack_public_path__ + "static/media/tone-brand-block.78636c7a.svg";